import React, { memo, useCallback } from 'react';
import CategoryItemBadge from './CategoryItemBadge';
import MerchantItemBadge from './MerchantItemBadge';
import ReceiptItemBadge from './ReceiptItemBadge';
import TagsItemBadge from './TagsItemBadge';
import AccountItemBadge from './AccountItemBadge';
import DateItemBadge from './DateItemBadge';
import AmountLowerItemBadge from './AmountLowerItemBadge';
import AmountUpperItemBadge from './AmountUpperItemBadge';
import SearchValueItemBadge from './SearchValueItemBadge';
const Filters = ({ scrollY, activeFilter, activeKeyboard, amountLowerValue, amountUpperValue, refAmountUpperInput, refAmountLowerInput, cancelEdit, onRemoveItem, scrollToItem, onChangeAmountUpper, onChangeAmountLower, onSearchValueChange, onToggleSelectedFilter, clearEmptyTextInputFilters, }) => {
    const renderItem = useCallback((item) => {
        if (item === 'CATEGORY' && activeFilter.CATEGORY) {
            return (<CategoryItemBadge key={item} filter={activeFilter.CATEGORY} scrollY={scrollY} scrollToItem={scrollToItem} handleClose={() => onRemoveItem('CATEGORY')} onPress={() => onToggleSelectedFilter(activeFilter.CATEGORY)} isActiveKeyboard={activeKeyboard === 'KeyboardCategories'}/>);
        }
        if (item === 'MERCHANT' && activeFilter.MERCHANT) {
            return (<MerchantItemBadge key={item} filter={activeFilter.MERCHANT} scrollY={scrollY} scrollToItem={scrollToItem} handleClose={() => onRemoveItem('MERCHANT')} onPress={() => onToggleSelectedFilter(activeFilter.MERCHANT)} isActiveKeyboard={activeKeyboard === 'KeyboardMerchants'}/>);
        }
        if (item === 'RECEIPT' && activeFilter.RECEIPT) {
            return (<ReceiptItemBadge key={item} scrollY={scrollY} scrollToItem={scrollToItem} handleClose={() => onRemoveItem(activeFilter.RECEIPT)} onPress={() => onToggleSelectedFilter(activeFilter.RECEIPT)} isActiveKeyboard={activeKeyboard === 'KeyboardReceipts'}/>);
        }
        if (item === 'TAG' && activeFilter.TAG) {
            return (<TagsItemBadge key={item} filter={activeFilter.TAG} scrollY={scrollY} scrollToItem={scrollToItem} handleClose={() => onRemoveItem('TAG')} onPress={() => onToggleSelectedFilter(activeFilter.TAG)} isActiveKeyboard={activeKeyboard === 'KeyboardTags'}/>);
        }
        if (item === 'ACCOUNT' && activeFilter.ACCOUNT) {
            return (<AccountItemBadge key={item} filter={activeFilter.ACCOUNT} scrollY={scrollY} scrollToItem={scrollToItem} handleClose={() => onRemoveItem('ACCOUNT')} onPress={() => onToggleSelectedFilter(activeFilter.ACCOUNT)} isActiveKeyboard={activeKeyboard === 'KeyboardAccounts'}/>);
        }
        if (item === 'DATES' && activeFilter.DATES) {
            return (<DateItemBadge key={item} scrollY={scrollY} filter={activeFilter.DATES} scrollToItem={scrollToItem} handleClose={() => onRemoveItem(activeFilter.DATES)} onPress={() => onToggleSelectedFilter(activeFilter.DATES)} isActiveKeyboard={activeKeyboard === 'KeyboardDates'}/>);
        }
        if (item === 'AMOUNT_LOWER' && activeFilter.AMOUNT_LOWER) {
            return (<AmountLowerItemBadge key={item} filter={activeFilter.AMOUNT_LOWER} scrollY={scrollY} cancelEdit={cancelEdit} scrollToItem={scrollToItem} amountLowerValue={amountLowerValue} handleClose={() => onRemoveItem(activeFilter.AMOUNT_LOWER)} refAmountLowerInput={refAmountLowerInput} onChangeAmountLower={onChangeAmountLower} onPress={() => onToggleSelectedFilter(activeFilter.AMOUNT_LOWER)} isActiveKeyboard={activeKeyboard === 'KeyboardAmountLower'}/>);
        }
        if (item === 'AMOUNT_UPPER' && activeFilter.AMOUNT_UPPER) {
            return (<AmountUpperItemBadge key={item} filter={activeFilter.AMOUNT_UPPER} scrollY={scrollY} cancelEdit={cancelEdit} scrollToItem={scrollToItem} amountUpperValue={amountUpperValue} handleClose={() => onRemoveItem(activeFilter.AMOUNT_UPPER)} refAmountUpperInput={refAmountUpperInput} onChangeAmountUpper={onChangeAmountUpper} onPress={() => onToggleSelectedFilter(activeFilter.AMOUNT_UPPER)} isActiveKeyboard={activeKeyboard === 'KeyboardAmountUpper'}/>);
        }
        if (item === 'TEXTINPUT' && activeFilter.TEXTINPUT) {
            return activeFilter.TEXTINPUT.map((eachFilter, index) => (<SearchValueItemBadge key={index} scrollY={scrollY} index={index} filter={eachFilter} cancelEdit={cancelEdit} scrollToItem={scrollToItem} onSearchValueChange={onSearchValueChange} handleClose={() => onRemoveItem(eachFilter)} clearEmptyTextInputFilters={clearEmptyTextInputFilters}/>));
        }
        return null;
    }, [
        activeFilter,
        activeKeyboard,
        amountLowerValue,
        amountUpperValue,
        cancelEdit,
        clearEmptyTextInputFilters,
        onChangeAmountLower,
        onChangeAmountUpper,
        onRemoveItem,
        onSearchValueChange,
        onToggleSelectedFilter,
        refAmountLowerInput,
        refAmountUpperInput,
        scrollToItem,
        scrollY,
    ]);
    if (!activeFilter || !Object.keys(activeFilter).length) {
        return null;
    }
    return <>{Object.keys(activeFilter).map((filterKey) => renderItem(filterKey))}</>;
};
export default memo(Filters);
